
import React from 'react';

const TermsContent_he: React.FC = () => (
    <div className="space-y-4 text-sm leading-relaxed text-slate-700" dir="rtl">
        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">1. בעלות על מתכונים וייחוס</h3>
            <p>
                בפרסום תוכן ב-mealPai, הנך מאשר ומסכים כי כל מתכון שנוסף ממקור חיצוני (כולל אך לא מוגבל לאתרי אינטרנט, ספרי בישול או בלוגים) שהוא זהה או דומה באופן מהותי למקור המקורי <strong>חייב לכלול קישור ישיר (URL) או אזכור</strong> ליוצר המקורי אם המתכון מסומן כ"ציבורי".
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">2. אחריות המשתמש וחבות</h3>
            <p>
                מתכונים ציבוריים המועתקים ממקור חיצוני ללא קרדיט או ייחוס מתאימים עלולים להוות הפרה של זכויות קניין רוחני.
            </p>
            <ul className="list-disc pr-5 mt-2 space-y-1">
                <li>
                    <strong>אחריות המשתמש:</strong> המשתמש המפרסם את התוכן הוא האחראי הבלעדי להבטיח שיש לו את הזכות לשתף את התוכן ולספק את הייחוס הנדרש.
                </li>
                <li>
                    <strong>הגבלת אחריות:</strong> mealPai, מפעיליה, עובדיה, מתנדביה ושותפיה (בתשלום או שלא בתשלום) <strong>לא יישאו באחריות או בחבות</strong> לכל מתכון שהועתק, פורסם או הופץ על ידי משתמשים ללא קרדיט נאות או תוך הפרת חוקי זכויות יוצרים.
                </li>
            </ul>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">3. שינויים ושימוש הוגן</h3>
            <p>
                משתמשים מוזמנים להציע שינויים, התאמות או שיפורים למתכונים. עם זאת, הצעות ופרסומים כאלה חייבים להישאר בגבולות חוקי זכויות היוצרים הרלוונטיים. שינוי מהותי של מתכון אינו שולל אוטומטית את הדרישה לייחוס אם היצירה הבסיסית נגזרת ממקור מוגן.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">4. תוכן והתנהגות אסורים</h3>
            <p>
                חל איסור מוחלט על משתמשים לפרסם תוכן הכולל שפה גסה, פוגענית, גזענית, אלימה, שיח שנאה או כל שפה בלתי הולמת אחרת.
            </p>
            <ul className="list-disc pr-5 mt-2 space-y-1">
                <li>
                    <strong>אפס סובלנות:</strong> mealPai שומרת על מדיניות של אפס סובלנות כלפי הטרדה, שיח שנאה ותוכן פוגעני.
                </li>
                <li>
                    <strong>השבתת חשבון:</strong> כל משתמש שיימצא אחראי לפרסום תוכן כזה יישא באחריות אישית. mealPai שומרת לעצמה את הזכות <strong>להשבית מיידית את החשבון</strong> של כל משתמש המפר מדיניות זו, ללא הודעה מוקדמת.
                </li>
            </ul>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">5. הסרת תוכן</h3>
            <p>
                mealPai שומרת לעצמה את הזכות, אך לא נוטלת על עצמה את החובה, להסיר כל תוכן שדווח או התגלה כמפר תנאים אלה או חוקי קניין רוחני רלוונטיים, ללא הודעה מוקדמת למשתמש.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">6. תמחור ומנויים</h3>
            <p>
                נכון לעכשיו, mealPai ניתן לשימוש ללא תשלום לצרכי בדיקה ושימוש אישי. עם זאת, אנו שומרים לעצמנו את הזכות להציג בעתיד תכניות מנוי בתשלום או עמלות שירות. גישה לתכונות פרימיום מסוימות או מכסות שימוש גבוהות יותר עשויות לדרוש מנוי בתשלום. משתמשים יקבלו הודעה מראש על כל שינוי מחייב במודל התמחור.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">7. המשכיות נתונים ואובדן מידע</h3>
            <p>
                למרות שאנו משקיעים מאמצים סבירים לשמור על אבטחת ושלמות הנתונים שלך, השירות ניתן כפי שהוא ("As Is"). אנו <strong>מסירים כל אחריות או חבות בגין אובדן נתונים</strong> (כולל מתכונים, תכניות ארוחות או היסטוריית חשבון) המתרחש לאורך זמן עקב תקלות טכניות, הגירות מערכת, כשלים במסדי נתונים או מחיקת חשבון.
            </p>
            <p className="mt-2">
                מומלץ מאוד למשתמשים להשתמש מעת לעת באפשרות <strong>"יצוא נתונים"</strong> הזמינה בתפריט כדי לשמור גיבויים אישיים של המידע שלהם.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">8. שימוש בבינה מלאכותית (AI) והצהרת אחריות</h3>
            <p>
                האפליקציה (mealPai) עושה שימוש בטכנולוגיות בינה מלאכותית (AI) לצורך ניתוח מתכונים, פירוט רכיבים, מתן אזהרות אלרגיה והתאמת ארוחות אישית למשתמש. יש לקחת בחשבון שטכנולוגיה זו אינה חסינה מטעויות ועשויה לעיתים לספק מידע שגוי, חסר או לא מדויק.
            </p>
            <p className="mt-2">
                המידע המופק על ידי הבינה המלאכותית מסופק כהמלצה ולמטרות מידע בלבד. על המשתמשים לנקוט משנה זהירות ולהפעיל שיקול דעת עצמאי. באחריות המשתמש הבלעדית לבדוק ולוודא בעצמו את רשימות הרכיבים ואזהרות האלרגיה (במיוחד במקרים של אלרגיות מסכנות חיים או מגבלות תזונתיות קפדניות) לפני כל הכנה או צריכה של מזון. ההסתמכות על מידע זה היא על אחריות המשתמש בלבד.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">9. לא גורם רפואי או ספק שירותי בריאות</h3>
            <p>
                mealPai הוא כלי לניהול קולינרי ותכנון משק בית, ולא ספק שירותי בריאות, דיאטנית או איש מקצוע רפואי. המידע שמסופק דרך אפליקציית mealPai (כולל אך לא מוגבל למתכונים, תכניות ארוחות, רשימות קניות ותוויות תזונתיות) נועד למטרות מידע וארגון בלבד. השימוש באפליקציה אינו יוצר קשר מטפל-מטופל או קשר ייעוץ-לקוח בינך לבין mealPai.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">10. מדידות והערכות תזונתיות</h3>
            <p>
                כל הערכים התזונתיים (כגון קלוריות, מאקרו ומיקרו-נוטריינטים), זמני ההכנה ומדידות הרכיבים שמופיעים בתוך האפליקציה הם הערכות אוטומטיות. הערכות אלו עשויות להיווצר באמצעות בינה מלאכותית של צד שלישי או להסתמך על תוכן שהוזן על ידי משתמשים. mealPai אינה מעניקה כל התחייבות לגבי הדיוק, השלמות או האמינות של ההערכות הללו.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">11. אחריות המשתמש הבלעדית לאלרגיות ומגבלות תזונתיות</h3>
            <p>
                mealPai אינה מבטיחה כי כל מתכון, תכנית ארוחות או רשימת קניות תהיה ללא אלרגנים או תעמוד במלואה במגבלות תזונתיות ספציפיות (למשל ללא גלוטן, קטו, טבעוני).
            </p>
            <p className="mt-2">
                <strong>אימות:</strong> באחריות המשתמש בלבד לקרוא בעיון את תוויות הרכיבים המופיעות על גבי מוצרים פיזיים, לוודא את מקור המוצרים ולוודא שכל המזון שנרכש והוכן הוא בטוח לצרכים הייחודיים של משק הבית ולדרישות האלרגיה שלך.
            </p>
            <p className="mt-2">
                <strong>היעדר אחריות:</strong> mealPai אינה נושאת באחריות לתגובות שליליות, מחלות שמקורן במזון, זיהומי הצלבה (cross-contamination), או לכל בעיה בריאותית הנובעת מההכנה או מהצריכה של המזון שנקבע בתכניות דרך האפליקציה.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">12. התייעצות עם אנשי מקצוע מוסמכים</h3>
            <p>
                אם יש לך מטרות בריאותיות ספציפיות (כגון ניהול משקל או ביצועים אתלטיים), אלרגיות מזון חמורות או מצבים רפואיים (כגון סוכרת או צליאק), עליך לפנות לייעוץ של רופא מורשה, דיאטנית רשומה או איש מקצוע רפואי מוסמך. בעוד ש-mealPai מאפשרת למשתמשים להתחבר ליועצים/מטפלים האישיים שלהם, mealPai עצמה אינה מאשרת ואינה מאמתת את היעילות הרפואית של כל תכנית שנוצרה בתוך האפליקציה.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">13. יצירת קשר בנושאים דחופים או מסכני חיים</h3>
            <p>
                במקרה של בעיה, תקלה או חשש בנוגע לשימוש באפליקציה—ובמיוחד אם מדובר במצב שעלול להיות מסכן חיים או דורש התייחסות דחופה—מומלץ ליצור קשר עם mealPai באמצעות אפשרות <strong>&quot;צור קשר&quot;</strong> בתפריט (דוא&quot;ל) או דרך <strong>&quot;תיבת הצעות&quot;</strong> באפליקציה.
            </p>
            <p className="mt-2">
                <strong>חשוב:</strong> mealPai אינה שירות חירום. במצב רפואי דחוף או מסכן חיים, יש לפנות מיידית לשירותי חירום או לאיש מקצוע רפואי מוסמך, ולא להסתמך על האפליקציה בלבד.
            </p>
        </section>
    </div>
);

export default TermsContent_he;
